import Observer from 'common/scripts/observer';
import {Utils} from 'common/scripts/utils';
import YandexMap from 'components/yandex-map';

const observer = new Observer();

class ParametricMap {
    constructor(options) {
        /**
         * Параметры
         */
        this.options = options;

        /**
         * Враппер карты
         */
        this.container = options.element ? options.element.querySelector('.j-parametric__map') : null;

        this.ymaps = window.ymaps;

        this.loadingClass = 'is-loading';
    }

    init() {
        if (!this.container || !this.ymaps) {
            return;
        }

        this._initElements();
        this._initMap();
        this._subscribes();
    }

    runLoading() {
        if (!this.container) {
            return;
        }

        this.container.classList.add(this.loadingClass);
    }

    stopLoading() {
        if (!this.container) {
            return;
        }

        this.container.classList.remove(this.loadingClass);
    }

    /**
     * Обновляет данные карты
     * @param {Object} data -объект данных
     */
    setMap(data) {
        if (!this.map || !data.complexes) {
            return;
        }

        this._collectMarkersData(data.complexes);
        this._updateFullMapData(data.map);
        this.map.update();
    }

    _initElements() {
        this.fullButton = this.container.querySelector('.j-parametric-map__full');
    }

    _initMap() {
        this.ymaps.ready(() => {
            this.map = new YandexMap(this.ymaps);

            this.map.init({
                wrapper                : this.container,
                cluster                : false,
                fullScreenControl      : false,
                customFullScreenControl: false,
                zoomControl            : false,
                customZoomControl      : false
            });
        });
    }

    _subscribes() {
        observer.subscribe('parametric:updateActiveMarker', (activeIndex) => {
            if (!this.map || !this.map.geoObjectCollectionArray) {
                return;
            }

            this.map.geoObjectCollectionArray.forEach((geoObject) => {
                this._setActiveMarkerParams(geoObject, activeIndex);
            });
        });
    }

    /**
     * Устанавливает класс активности и тип курсора для активного маркера на карте
     * @param {Object} geoObject - Объект (яндекс-карт) маркера на карте
     * @param {String} activeIndex - ID активного объекта
     * @private
     */
    _setActiveMarkerParams(geoObject, activeIndex) {
        geoObject.getOverlay().then((geoObjectOverlay) => {
            this._getDomElement(geoObjectOverlay);

            const isMarkerActive = this.domMarker.dataset.markerId === activeIndex;
            const cursor = isMarkerActive ? 'pointer' : 'default';
            const zIndex = isMarkerActive ? 1 : 0;

            geoObject.options.set('cursor', cursor);
            geoObject.options.set('zIndex', zIndex);
            this.domMarker.classList.toggle('is-active', isMarkerActive);

            if (this.domMarker.dataset.markerId === activeIndex) {
                this._setMapBounds(geoObject);
            }
        });
    }

    /**
     * Достаёт DOM-элемент пина из карты
     * @param {Object} geoObjectOverlay - Объект (яндекс-карт) маркера на карте
     * @private
     */
    _getDomElement(geoObjectOverlay) {
        // eslint-disable-next-line
        const domTarget = geoObjectOverlay.getLayoutSync().getElement();

        this.domMarker = domTarget.querySelector('.j-yandex-map__marker');
    }

    /**
     * Если маркер не виден на карте, то центрируем карту к маркеру
     * @param {Object} marker - объект (яндекс-карт) активного маркера
     * @private
     */
    _setMapBounds(marker) {
        // Вписывается ли маркер в область видимости карты
        const contains = this.ymaps.util.bounds.containsPoint(this.map.map.getBounds(),
            marker.geometry.getCoordinates());

        if (!contains) {
            this.map.map.setCenter(marker.geometry.getCoordinates(), this.map.map.getZoom(), {
                duration: 300
            });
        }
    }

    _collectMarkersData(data) {
        this.markers = [];
        this.markersFullMap = [];

        for (const complex of data) {
            if (complex.marker) {
                // глубокое копирование
                const fullMapMarker = JSON.parse(JSON.stringify(complex.marker));

                this.markersFullMap.push(fullMapMarker);

                complex.marker.modifyClass = 'object';
                this.markers.push(complex.marker);
            }
        }

        Object.assign(this.map.settings, {markers: this.markers});
    }

    /**
     * Обновляет данные карты в попапе
     * @param {Object} mapData - новые данные для карты
     * @private
     */
    _updateFullMapData(mapData = {}) {
        if (!this.fullButton) {
            return;
        }

        const base64 = this.fullButton.dataset.mapJson;
        const fullButtonSettings = JSON.parse(Utils.fromBase64(base64));

        Object.assign(fullButtonSettings.data, mapData);
        Object.assign(fullButtonSettings.data, {markers: this.markersFullMap});

        this.fullButton.dataset.mapJson = Utils.toBase64(JSON.stringify(fullButtonSettings));
    }
}

export default ParametricMap;
